import { ServiceBanner } from "./ServiceBanner";
import { WellnessPrompt } from "./wellness/WellnessPrompt";
import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import {
  LayoutDashboard, Users, Activity, Salad, LineChart, MessageSquare, Bookmark,
  LogOut, Settings, Menu, X, Package, ClipboardList, Dumbbell,
  AlertOctagon, HeartPulse, SlidersHorizontal, Zap, Trophy, Calendar, Sparkles, TrendingUp, Inbox, UserPlus, ClipboardCheck, BookOpen, BellRing, UserCircle, Apple,
} from "lucide-react";
import { useAuth } from "../lib/auth";

const QV_LOGO =
  "https://customer-assets.emergentagent.com/job_athletic-edge-19/artifacts/7jyn9i1w_IMG_2453.PNG";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "admin";
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth <= 900 : false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // close drawer on route change & scroll to top
  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const adminLinks = [
    { to: "/app/admin", icon: LayoutDashboard, label: "Dashboard" },
    { to: "/app/admin/atencion", icon: AlertOctagon, label: "Atención" },
    { to: "/app/admin/bienestar", icon: HeartPulse, label: "Bienestar" },
    { to: "/app/admin/autorregulacion", icon: SlidersHorizontal, label: "Reglas de autorregulación" },
    { to: "/app/admin/clients", icon: Users, label: "Clientes" },
    { to: "/app/admin/gestion", icon: TrendingUp, label: "Gestión" },
    { to: "/app/admin/leads", icon: Inbox, label: "Leads" },
    { to: "/app/admin/incorporaciones", icon: UserPlus, label: "Incorporaciones" },
    { to: "/app/admin/planificaciones", icon: ClipboardCheck, label: "Planificaciones" },
    { to: "/app/admin/metodologia", icon: BookOpen, label: "Mi metodología" },
    { to: "/app/admin/nutricion", icon: Apple, label: "Nutrición" },
    { to: "/app/admin/vencimientos", icon: BellRing, label: "Vencimientos" },
    { to: "/app/admin/diagnosticos", icon: ClipboardList, label: "Diagnósticos" },
    { to: "/app/admin/plans-v2", icon: Zap, label: "Planes V2" },
    { to: "/app/admin/plantillas-v2", icon: Bookmark, label: "Plantillas V2" },
    { to: "/app/admin/partidos", icon: Calendar, label: "Partidos" },
    { to: "/app/admin/biblioteca-tests", icon: ClipboardCheck, label: "Biblioteca de tests" },
    { to: "/app/admin/tests-v2", icon: Trophy, label: "Tests V2" },
    { to: "/app/admin/ejercicios", icon: Dumbbell, label: "Ejercicios" },
    { to: "/app/admin/plantillas", icon: Bookmark, label: "Plantillas" },
    { to: "/app/admin/programas", icon: Package, label: "Programas" },
    { to: "/app/admin/feedback", icon: MessageSquare, label: "Feedback" },
  ];
  const clientLinks = [
    { to: "/app/mi-area", icon: UserCircle, label: "Mi área" },
    { to: "/app/mi", icon: Sparkles, label: "Hoy" },
    { to: "/app/bienestar", icon: HeartPulse, label: "Bienestar diario" },
    { to: "/app/dashboard", icon: LayoutDashboard, label: "Inicio" },
    { to: "/app/mi-planificacion", icon: ClipboardCheck, label: "Mi planificación" },
    { to: "/app/readiness", icon: Zap, label: "Readiness" },
    { to: "/app/entrenamiento", icon: Activity, label: "Entrenamiento" },
    { to: "/app/nutricion", icon: Salad, label: "Nutrición" },
    { to: "/app/tests", icon: LineChart, label: "Tests" },
    { to: "/app/feedback", icon: MessageSquare, label: "Feedback" },
    { to: "/app/programas", icon: Package, label: "Programas" },
  ];
  const links = isAdmin ? adminLinks : clientLinks;

  const Sidebar = (
    <>
      {isMobile && open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(2px)", zIndex: 85,
          }}
        />
      )}
      <aside
        style={{
          background: "#0a0a0a",
          borderRight: "1px solid rgba(255,255,255,0.06)",
          padding: "24px 18px",
          display: "flex",
          flexDirection: "column",
          ...(isMobile
            ? {
                position: "fixed",
                top: 0,
                left: 0,
                height: "100vh",
                width: 280,
                maxWidth: "86vw",
                zIndex: 90,
                transform: open ? "translateX(0)" : "translateX(-100%)",
                transition: "transform .28s cubic-bezier(.2,.7,.2,1)",
                boxShadow: open ? "0 0 60px rgba(0,0,0,0.8)" : "none",
                visibility: open ? "visible" : "hidden",
                overflowY: "auto",
                overflowX: "hidden",
                WebkitOverflowScrolling: "touch",
                overscrollBehavior: "contain",
                paddingBottom: "calc(24px + env(safe-area-inset-bottom, 0px))",
              }
            : {
                position: "fixed",
                top: 0,
                left: 0,
                height: "100vh",
                width: 260,
                zIndex: 50,
                overflowY: "auto",
              }),
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <div className="qv-side-brand" style={{ borderBottom: "none", marginBottom: 0, padding: 0 }}>
            <img src={QV_LOGO} alt="QV" />
            <div>
              <div className="t1">QUIQUE VARGAS</div>
              <div className="t2">Plataforma Rendimiento</div>
            </div>
          </div>
          {isMobile && (
            <button onClick={() => setOpen(false)} style={{ background: "transparent", border: "none", color: "#fff", cursor: "pointer", padding: 4 }}>
              <X size={20} />
            </button>
          )}
        </div>
        <nav className="qv-nav" style={{ flex: 1 }}>
          <div className="qv-nav-section">{isAdmin ? "Admin" : "Mi área"}</div>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/app/admin" || l.to === "/app/dashboard"}
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              <l.icon size={16} />
              {l.label}
            </NavLink>
          ))}
          <div className="qv-nav-section">Cuenta</div>
          <NavLink to="/app/ajustes" data-testid="nav-ajustes">
            <Settings size={16} />
            Ajustes
          </NavLink>
          <button
            onClick={logout}
            style={{
              display: "flex", alignItems: "center", gap: 12, padding: "11px 12px",
              background: "transparent", border: "none", color: "#cfcfcf",
              cursor: "pointer", fontSize: 14, width: "100%", textAlign: "left",
            }}
            data-testid="nav-logout"
          >
            <LogOut size={16} />
            Salir
          </button>
        </nav>
        <div style={{ paddingTop: 18, borderTop: "1px solid rgba(255,255,255,0.06)" }}>
          <div className="qv-side-user">
            <div className="nm">{user?.name}</div>
            <div className="em">{user?.email}</div>
            <div style={{ marginTop: 8, fontSize: 10, letterSpacing: "0.22em", textTransform: "uppercase", color: "#737373" }}>
              {user?.role === "admin" ? "Entrenador" : "Jugador"}
            </div>
          </div>
          <button
            onClick={() => navigate("/")}
            style={{
              marginTop: 12, fontSize: 11, letterSpacing: "0.22em",
              textTransform: "uppercase", color: "#737373", background: "transparent",
              border: "none", cursor: "pointer", padding: 4,
            }}
          >
            ← Volver a la web
          </button>
        </div>
      </aside>
    </>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#050505", color: "#fff" }}>
      {/* Mobile top bar */}
      {isMobile && (
        <header
          style={{
            position: "sticky", top: 0, zIndex: 70, height: 56,
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "0 16px",
            background: "rgba(5,5,5,0.92)",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            borderBottom: "1px solid rgba(255,255,255,0.06)",
          }}
          data-testid="qv-topbar"
        >
          <button
            aria-label="Abrir menú"
            onClick={() => setOpen(true)}
            style={{ background: "transparent", border: "none", color: "#fff", cursor: "pointer", padding: 6 }}
            data-testid="qv-burger"
          >
            <Menu size={22} />
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: 8, fontFamily: "Bebas Neue, sans-serif", fontSize: "0.95rem", letterSpacing: "0.06em" }}>
            <img src={QV_LOGO} alt="QV" style={{ width: 30, height: 30, objectFit: "contain" }} />
            <span>QUIQUE VARGAS</span>
          </div>
          <div style={{ width: 22 }} />
        </header>
      )}

      {typeof document !== "undefined" && createPortal(Sidebar, document.body)}

      <main
        style={{
          padding: isMobile ? "22px 16px 60px" : "36px 40px",
          marginLeft: isMobile ? 0 : 260,
          maxWidth: isMobile ? "100%" : 1400,
          width: isMobile ? "100%" : "auto",
          boxSizing: "border-box",
        }}
      >
        {user?.role === "client" && <ServiceBanner />}
        {user?.role === "client" && <WellnessPrompt />}
        {children}
      </main>
    </div>
  );
}
